// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");

function make(latitude, longitude) {
  return {
          latitude: latitude,
          longitude: longitude
        };
}

function decode(json) {
  return Curry._2(Json.Decode.$less$star$great, Curry._2(Json.Decode.$less$$great, (function (latitude, longitude) {
                    return {
                            latitude: latitude,
                            longitude: longitude
                          };
                  }), Curry._3(Json.Decode.field, "lat", Json.Decode.floatFromNumber, json)), Curry._3(Json.Decode.field, "lng", Json.Decode.floatFromNumber, json));
}

function convertToRadians(param) {
  var partial_arg = Math.PI / 180.0;
  var convertToRadians$1 = function (param) {
    return partial_arg * param;
  };
  return [
          Curry._1(convertToRadians$1, param.latitude),
          Curry._1(convertToRadians$1, param.longitude)
        ];
}

function kilometersToMiles(km) {
  return km / 1.60934;
}

function distanceBetweenKm(a, b) {
  var match = convertToRadians(a);
  var latA = match[0];
  var match$1 = convertToRadians(b);
  var distanceLat = match$1[0] - latA;
  var distanceLng = (match$1[1] - match[1]) * Math.cos(latA);
  return 6371.0 * Math.sqrt(Math.pow(distanceLat, 2.0) + Math.pow(distanceLng, 2.0));
}

function distanceBetweenMiles(a, b) {
  return distanceBetweenKm(a, b) / 1.60934;
}

exports.make = make;
exports.decode = decode;
exports.convertToRadians = convertToRadians;
exports.kilometersToMiles = kilometersToMiles;
exports.distanceBetweenKm = distanceBetweenKm;
exports.distanceBetweenMiles = distanceBetweenMiles;
/* Json Not a pure module */
